import { useCallback, useMemo } from 'react';
import { useFullLesson } from '../lessons/lessonQueries';
import { useFullTrack } from '../tracks/tracksQueries';
import { useVideoPlayerConfig } from './videoHooks';
export const useVideo = ({
  contentId,
  lessonId,
  trackId,
  language
}) => {
  const {
    lesson
  } = useFullLesson(Number(lessonId), language, !lessonId, trackId ? 'cache-only' : 'cache-first');
  const {
    track
  } = useFullTrack(Number(trackId), language);
  const getLessonVideo = useCallback(() => {
    if (!lesson) return undefined;
    if (contentId) return lesson.content.find(content => content.id === Number(contentId));
    const firstVideoContent = lesson.content.find(content => content.reference);
    if (!firstVideoContent) return undefined;
    return firstVideoContent;
  }, [contentId, lesson]);
  const getTrackVideo = useCallback(() => {
    if (track) {
      let firstLessonVideoContent = undefined;
      if (track.lessons) {
        for (const trackLesson of track.lessons) {
          firstLessonVideoContent = trackLesson.content.find(content => content.reference);
          if (firstLessonVideoContent) break;
        }
      }
      if (track.introVideo) return track.introVideo;else if (firstLessonVideoContent) return firstLessonVideoContent;else return undefined;
    }
    return undefined;
  }, [track]);
  const video = useMemo(() => lessonId ? getLessonVideo() : getTrackVideo(), [getLessonVideo, getTrackVideo, lessonId]);
  const businessObjectives = lesson ? lesson.businessObjectives : track ? track.businessObjectives : [];
  const useCases = lesson ? lesson.useCases : track ? track.useCases : [];
  const {
    autoPlay,
    playSpeed
  } = useVideoPlayerConfig();
  const {
    reference: videoId,
    hubId: creatorHubId,
    duration: videoDuration,
    hublet: creatorRegion
  } = video || {};
  return {
    videoId,
    autoPlay,
    playSpeed,
    creatorHubId,
    videoDuration,
    businessObjectives,
    useCases,
    creatorRegion
  };
};